import {Filter} from '../features/orders/data-access/interfaces/filter.interface';

export interface ListRequest {
  pageSize: number;
  currentPage: number;
  sort: string;
  sortDirection: 'asc' | 'desc' | '';
  filters?: Filter[] | null;
  conjunctionType?: ConjunctionType;
  mode?: 'BASIC' | 'ADVANCED'; // (optional; default on backend is ADVANCED)
}

export enum ConjunctionType {
  OR = 'OR',
  AND = 'AND',
}
